<template>
  <div class="company-index-page margin-l-20 margin-r-20">
    <div class="company-index-header">
      <el-select v-model="companyForm.district" placeholder="请选择"  size="small" @change="getAll" class="margin-l-20">
        <el-option v-for = 'item in typeList'  :key="item.value" :label="item.value" :value="item.value"></el-option>
      </el-select>
      <el-date-picker class="margin-l-20" v-model="companyForm.times" type="month" placeholder="选择月" :clearable="false"
                      format="yyyy-MM" value-format="yyyy-MM" @change="getAll" :picker-options="pickerOptions"></el-date-picker>
      <el-input placeholder="公司名称、法人、社会信用代码" v-model="companyForm.keyWord" prefix-icon="el-icon-search" clearable size="small"
                style="width: 320px;margin-top: 12px;float: right;margin-right: 20px">
        <el-button slot="append" class="lookFor" @click="getAll">查询</el-button>
      </el-input>
    </div>
    <div class="margin-t-30 margin-b-20">
      截止{{companyForm.times}},全市共计监测企业数{{companyTotal.companyNum}}家,店铺数{{companyTotal.shopNum}}家
<!--      ，当期网络零售额{{companyTotal.money}}万元，累计网络零售额{{companyTotal.ljMoney}}万元-->
      <div class="float-right cursor-pointer" @click="downCompany()">
        <i class="el-icon-download font-18 text-ff7f00"></i><span class="font-18">批量下载</span>
      </div>
    </div>
    <el-card class="company-index-content">
      <el-table :data="companyList" width="480px" stripe @row-click="tableDetail" class="border-DEDEDE"
                :default-sort="{prop: 'money', order: 'descending'}">
        <el-table-column prop="rank" label="排名" align="center" width="60" ></el-table-column>
        <el-table-column prop="companyname" label="企业名称" align="center"></el-table-column>
<!--        <el-table-column prop="comIndexShow" label="企业综合得分" width="120" align="center"></el-table-column>-->
        <el-table-column prop="opername" label="法定代表人" width="120" align="center"></el-table-column>
        <el-table-column prop="address" label="注册地址" width="180" align="center"></el-table-column>
        <el-table-column prop="econkind" label="企业类型" align="center"></el-table-column>
        <el-table-column  label="当期网络零售额（万元）" align="center">
          <template slot-scope="scope">
            {{ scope.row.salesofmonthstr || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="salesofyearstr" label="累计网络零售额（万元）" align="center">
          <template slot-scope="scope">
            {{ scope.row.salesofyearstr || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="keyno" label="统一社会信用代码" align="center"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next"
        :total="total" :page-size="pageSize" @current-change="handleCurrentChange" class="margin-t-30 text-center">
      </el-pagination>
    </el-card>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A margin-t-20">
      注：<br/>
      1.平台范围：企业平台范围：天猫商城、京东商城、淘宝网、苏宁易购、国美在线、当当网、亚马逊（中国）、唯品会、拼多多、卷皮网、速卖通、贝贝网、国网商城、环球捕手、融e购、邮乐购、e城e品、供销e家、乐村淘、聚美优品、建行善融、寺库网、汽车之家、顺丰优选、云集、值点商城、考拉海购、兴盛优选、必要商城等29个平台；<br/>
      2.2021年1月，纳入聚美优品、建行善融、寺库网、汽车之家、顺丰优选、云集、值点商城、考拉海购。2021年8月，纳入兴盛优选、必要商城。<br/>

    </p>
  </div>
</template>

<script>
  export default {
    name: 'company-index',
    data () {
      return {
        isHave: false,
        moneyValue: '',
        input: '',
        restaurants: [],
        companyTotal:{},//宏观数据
        state: '',
        salesTable: {},//重点赣企销售额排行
        yoyTable: {},//重点赣企增速排行
        timeout: null,
        value:"九江市",
        typeList:[{'value':'九江市'},{'value':'柴桑区'},{'value':'德安县'},{'value':'都昌县'},{'value':'共青城市'},
          {'value':'湖口县'},{'value':'濂溪区'},{'value':'庐山市'},{'value':'彭泽县'},{'value':'瑞昌市'},{'value':'武宁县'},
          {'value':'修水县'},{'value':'浔阳区'},{'value':'永修县'}],
        total: 100,
        currentPage: 1, //初始页
        pageSize: 10,    //    每页的数据
        companyForm: {times: '', money: '全部', keyWord: '', sMoney: '', eMoney: '',district:'九江市'},
        companyList: [],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    created () {
      this.$emit('public_header', true)
    },
    methods: {
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
        this.getCompanyByInfo()
      },
      tableDetail(row){
        this.goToDetail(row.id)
      },
      getAll(){
        this.getAllInfo()
        this.getCompanyByInfo()
      },
      getInvestInfo () {
        if (this.moneyValue == '自定义') {
          this.isHave = true
        }
      },
      aaa () {
        this.isHave = true
        console.dir(this.isHave)
      },
      //关键字模糊搜索企业
      getCompanyByInfo () {
        this.$http.get(this.header + '/importantCompany/search', {
          params: {
            times: this.companyForm.times,
            limit: this.pageSize,
            page: this.currentPage,
            district: this.companyForm.district,
            keyWord: this.companyForm.keyWord,
            sMoney: this.companyForm.sMoney,
            eMoney: this.companyForm.eMoney
          }
        }).then(res => {
          if (res.data.code == 0) {
            if (res.data.page) {
              this.companyList = res.data.page.list
              this.total = res.data.page.totalCount
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      downCompany () {
        // this.$router.push(this.header+'/qyjc/exportXlsx?'+'type='+type+'&index_type='+this.chooseType+'&times='+this.allForm.times+'&platform='+platform)
        window.open(this.header+'/importantCompany/exportXlsx?'+'keyWord='+this.companyForm.keyWord+'&district='+this.companyForm.district+'&times='+this.companyForm.times);
      },
      //企业库概览信息
      getAllInfo () {
        this.$http.get(this.header + '/importantCompany/total', {
          params: {
            times: this.companyForm.times,
          }
        }).then(res => {
          if (res.data.code == 0) {
            if (res.data.total) {
              this.companyTotal = res.data.total
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //选择近1个月
      oneMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          // this.companyForm.times = dataArr[1]
          this.companyForm.times = dataArr[1]
        } else {
          this.companyForm.times = dataArr[2]
        }
        this.getCompanyByInfo()
        this.getAllInfo()
      },
      //返回输入建议的方法，仅当你的输入建议数据 resolve 时，通过调用 callback(data:[]) 来返回它
      querySearchAsync (queryString, cb) {
        this.state = queryString
        this.$http.get(this.header + '/gpjc/gq/catalogue', {
          params: {
            keyWord: this.state
          }
        }).then(res => {
          if (res.data.code == 0) {
            if (res.data.list) {
              this.restaurants = res.data.list
              // var results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
              // let results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
              console.log(this.restaurants)
              cb(this.restaurants)
            }
          } else {
            this.$alert(res.data.msg)
          }

        })

      },

      //点击选中建议项时触发
      goToDetail (id) {
        let page = this.$router.resolve({
          name: 'companyDetail',
          query: {
            id: id
          }
        })
        window.open(page.href, '_blank')
        // this.$router.push({
        //   path: '/companyDetail',
        //   query: {
        //     id: id
        //   }
        // })
      }
    },
    mounted () {
      this.oneMonth()
      // this.restaurants = this.loadAll()
      // this.getCompanyTop()
    }
  }
</script>

<style>
  .company-index-page .company-index-header {
    text-align: left;
    margin-bottom: 8px;
    height: 54px;
    line-height: 54px;
    background: white;
    /*border: 1px solid rgba(100, 156, 238, 0.4);*/
    box-shadow: 0px 6px 7px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    color: #6589C5;
  }

  .companyMoney-choose .el-input__inner {
    padding: 0 5px;
    height: 26px;
  }

  /*.company-index-page .company-index-header ul li:nth-child(5):hover .bbb{*/
  /*  display: block;*/
  /*}*/
  .el-select-dropdown__item:nth-child(5):hover {
    position: relative;
  }

  .bbb {
    display: none;
    position: absolute;
    top: 0;
    left: 100%;
    z-index: 100
  }

  .el-select-dropdown__item:nth-child(5):hover .bbb {
    /*display: block;*/
  }

  .el-select-dropdown__item:nth-child(5):hover {

    /*background-color: red;*/
  }

  .company-index-page .el-select .el-input__inner,.company-index-page .el-date-editor--month .el-input__inner {
    height: 30px;
    width: 130px;
    background-color: rgba(255, 255, 255, 1) !important;
    /*border-radius: 25px;*/
    color: #6B7991 !important;
  }

  .company-index-page .company-index-content h2 {
    font-size: 24px;
    /* font-family: Source Han Sans CN; */
    font-weight: bold;
    color: #666;
  }

  .company-index-page .company-index-content .list span {
    margin-right: 30px;
    color: #666;
  }

  .company-index-page .el-autocomplete {
    width: 100%;
  }

  .company-index-page .el-autocomplete-suggestion {
    height: 500px;
  }

  .company-index-page .el-autocomplete-suggestion__wrap {
    max-height: 700px;
  }

  .company-index-page .rank .el-card {
    background-color: #262A31 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/company-index.vue